var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multi-reservation-card',{attrs:{"data-cy":"multi-reservation-page","reservations":_vm.availableReservations,"hotel":_vm.hotel},on:{"select":function($event){return _vm.$store.dispatch('search/selectReservation', $event)},"back":function($event){return _vm.$store.dispatch('flow/reservation/previous')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }